import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

export default function LandingNavbar() {
  const [menuOpen, setMenuOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 10);
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <nav
      style={{
        position: 'sticky',
        top: 0,
        zIndex: 50,
        background: '#ffffff',
        borderBottom: scrolled ? '1px solid #e2e8f0' : '1px solid #f1f5f9',
        transition: 'border-color 0.2s',
        fontFamily: "'Plus Jakarta Sans', sans-serif",
      }}
    >
      <div style={{ maxWidth: 1120, margin: '0 auto', padding: '0 20px', height: 60, display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
        {/* Wordmark */}
        <Link to="/" style={{ textDecoration: 'none', display: 'flex', alignItems: 'center', gap: 8, flexShrink: 0 }}>
          <span style={{ width: 8, height: 8, borderRadius: 2, background: '#EA580C', display: 'inline-block', flexShrink: 0 }} />
          <span style={{ fontWeight: 800, fontSize: 17, color: '#0f172a', letterSpacing: '-0.3px' }}>MetalRecovery</span>
        </Link>

        {/* Desktop nav */}
        <div style={{ display: 'flex', alignItems: 'center', gap: 8 }} className="landing-desktop-nav">
          <Link
            to="/login"
            style={{ color: '#64748b', fontSize: 14, fontWeight: 500, textDecoration: 'none', padding: '8px 14px', borderRadius: 8 }}
          >
            Iniciar sesión
          </Link>
          <Link
            to="/login"
            style={{
              background: '#EA580C',
              color: '#ffffff',
              fontSize: 14,
              fontWeight: 600,
              textDecoration: 'none',
              padding: '9px 20px',
              borderRadius: 999,
              transition: 'background 0.15s',
            }}
            onMouseEnter={e => e.currentTarget.style.background = '#c2410c'}
            onMouseLeave={e => e.currentTarget.style.background = '#EA580C'}
          >
            Probar demo
          </Link>
        </div>

        {/* Mobile hamburger — min 44×44 touch target */}
        <button
          onClick={() => setMenuOpen(!menuOpen)}
          className="landing-hamburger"
          aria-label={menuOpen ? 'Cerrar menú' : 'Abrir menú'}
          aria-expanded={menuOpen}
          style={{
            display: 'none',
            background: 'none',
            border: 'none',
            cursor: 'pointer',
            padding: '10px 8px',
            minWidth: 44,
            minHeight: 44,
            alignItems: 'center',
            justifyContent: 'center',
            flexDirection: 'column',
            gap: 5,
            borderRadius: 8,
          }}
        >
          <span style={{
            display: 'block',
            width: 22,
            height: 2,
            background: menuOpen ? '#EA580C' : '#334155',
            borderRadius: 2,
            transition: 'background 0.2s, transform 0.2s',
            transform: menuOpen ? 'rotate(45deg) translate(5px, 5px)' : 'none',
          }} />
          <span style={{
            display: 'block',
            width: 22,
            height: 2,
            background: menuOpen ? '#EA580C' : '#334155',
            borderRadius: 2,
            transition: 'opacity 0.2s',
            opacity: menuOpen ? 0 : 1,
          }} />
          <span style={{
            display: 'block',
            width: 22,
            height: 2,
            background: menuOpen ? '#EA580C' : '#334155',
            borderRadius: 2,
            transition: 'background 0.2s, transform 0.2s',
            transform: menuOpen ? 'rotate(-45deg) translate(5px, -5px)' : 'none',
          }} />
        </button>
      </div>

      {/* Mobile menu */}
      {menuOpen && (
        <div style={{ background: '#ffffff', borderTop: '1px solid #f1f5f9', padding: '8px 20px 16px' }}>
          <Link
            to="/login"
            onClick={() => setMenuOpen(false)}
            style={{
              display: 'flex',
              alignItems: 'center',
              color: '#64748b',
              fontSize: 15,
              fontWeight: 500,
              textDecoration: 'none',
              padding: '14px 0',
              borderBottom: '1px solid #f1f5f9',
              minHeight: 48,
            }}
          >
            Iniciar sesión
          </Link>
          <Link
            to="/login"
            onClick={() => setMenuOpen(false)}
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              marginTop: 12,
              background: '#EA580C',
              color: '#fff',
              fontSize: 15,
              fontWeight: 600,
              textDecoration: 'none',
              padding: '14px 20px',
              borderRadius: 999,
              textAlign: 'center',
              minHeight: 48,
            }}
          >
            Probar demo
          </Link>
        </div>
      )}

      <style>{`
        @media (max-width: 640px) {
          .landing-desktop-nav { display: none !important; }
          .landing-hamburger { display: flex !important; }
        }
      `}</style>
    </nav>
  );
}
